import { Box, MenuButton } from '@chakra-ui/react';
import { IconButton } from 'Atoms/Buttons/Buttons.tsx';
import { Tooltip } from 'Atoms/Tooltip/Tooltip.tsx';
import { VisibleIf } from 'Atoms/VisibleIf/VisibleIf.tsx';
import { Menu } from 'Molecules/Menu/Menu.tsx';
import { BusinessUnitsIcon, FolderIcon } from 'Tokens/Icons/Data.tsx';
import { AddIcon } from 'Tokens/Icons/Function.tsx';
import { HelpIcon } from 'Tokens/Icons/Status.tsx';
import { useGetCurrentCAssessment } from 'utils/hooks/General.hooks.ts';
import { useTranslation } from 'utils/translation/translation.ts';

export const CompanyStructureAddMenu = ({
  setSelectedParentGroup,
  onCreateBU,
  onCreateGroup,
}: {
  setSelectedParentGroup: (parent: string | undefined) => void;
  onCreateBU: () => void;
  onCreateGroup: () => void;
}) => {
  const { t } = useTranslation([]);
  const { isLocked } = useGetCurrentCAssessment();

  return (
    <VisibleIf condition={!isLocked}>
      <Menu
        size="lg"
        menuButton={
          <MenuButton
            as={IconButton}
            aria-label="add"
            size="sm"
            variant="secondary"
            icon={<AddIcon color="inherit" />}
          />
        }
        sections={[
          {
            actions: [
              {
                id: 'add-reporting-unit',
                leftElement: <BusinessUnitsIcon color="inherit" />,
                onClick: () => {
                  setSelectedParentGroup(undefined);
                  onCreateBU();
                },
                title: t('assessment:structure.businessUnit.create'),
                rightElement: (
                  <Tooltip placement="right-start" label={t('assessment:reportsTooltip.buTooltip')}>
                    <Box>
                      <HelpIcon marginTop="6px" color="inherit" />
                    </Box>
                  </Tooltip>
                ),
              },
              {
                id: 'add-reporting-group',
                leftElement: <FolderIcon color="inherit" />,
                onClick: () => {
                  setSelectedParentGroup(undefined);
                  onCreateGroup();
                },
                title: t('assessment:structure.department.create'),
                rightElement: (
                  <Tooltip label={t('assessment:reportsTooltip.rgTooltip')} placement="right-start">
                    <Box>
                      <HelpIcon marginTop="6px" color="inherit" />
                    </Box>
                  </Tooltip>
                ),
              },
            ],
          },
        ]}
      />
    </VisibleIf>
  );
};
